export default {
  accounts: [],
  account: undefined,
};
